import { Button } from "antd";
import { jsPDF } from "jspdf";
import { useTranslation } from "react-i18next";

const ExportButtons = ({ data }: { data: any[] }) => {
  const { t } = useTranslation();
  const handleExportPDF = () => {
    const doc = new jsPDF();

    doc.text("Tabela Podataka", 20, 20);

    let y = 30;
    data.forEach((row, index) => {
      doc.text(
        `${row.title} - ${row.description} - ${row.costs} - ${row.date}`,
        20,
        y
      );
      y += 10;
    });

    doc.save("tabela.pdf");
  };

  const handleExportCSV = () => {
    const csvRows = [
      ["Title", "Description", "Costs", "Date"], // Headline
      ...data.map((row) => [row.title, row.description, row.costs, row.date]),
    ];

    const csvContent = csvRows.map((row) => row.join(",")).join("\n");

    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const link = document.createElement("a");
    if (link.download !== undefined) {
      const url = URL.createObjectURL(blob);
      link.setAttribute("href", url);
      link.setAttribute("download", "tabela.csv");
      link.click();
    }
  };

  return (
    <div className="exportNotesBtn">
      {/* <button onClick={handleExportPDF}>Export to PDF</button> */}
      <Button onClick={handleExportCSV}>{t("Export to CSV")}</Button>
    </div>
  );
};

export default ExportButtons;
